export default __webpack_public_path__ + "static/media/gallery-wip-control-box_05.a823434c.jpg";